import styled, { css, DefaultTheme } from 'styled-components';

export default styled.div<{ hasDropdown: boolean; theme: DefaultTheme }>`
  ${({ hasDropdown, theme }) => {
    return css`
      display: flex;
      justify-content: space-between;
      flex-direction: ${hasDropdown ? 'column' : 'row'};
      border-bottom: 0.125em solid var(--color-neutral-20);
      margin: 1em;
      padding-bottom: 1em;
      background: var(--color-white);
      @media ${theme.mq.min.mobile} {
        flex-direction: row;
      }
      .listing-header__title {
        font-weight: 700;
        font-size: 0.875em;
        line-height: 1.5em;
        letter-spacing: 0.01em;
        text-transform: uppercase;
        margin: 0;
        padding: ${hasDropdown ? '0.375em' : '0'};
      }
      .listing-header__col {
        display: flex;
        align-items: center;
        margin-left: 0.5em;
      }
      ${hasDropdown &&
      css`
        .listing-header__col {
          margin: 0.5em 0 0 0;
          justify-content: space-between;
          @media ${theme.mq.min.mobile} {
            margin: 0;
            justify-content: center;
          }
        }
      `}
    `;
  }}
`;
